import { BaseAPIModel } from '@weezevent/weezjs-core';

export class EmailLogDetails extends BaseAPIModel {
    fields() {
        return {
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl({ organizationId, messageUuid }) {
        return `/mail/organizations/${organizationId}/messages/${messageUuid}/actions`;
    }
}
